import { render, staticRenderFns } from "./Mall.vue?vue&type=template&id=236d88b4&scoped=true&"
import script from "./Mall.vue?vue&type=script&lang=ts&"
export * from "./Mall.vue?vue&type=script&lang=ts&"
import style0 from "./Mall.vue?vue&type=style&index=0&id=236d88b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236d88b4",
  null
  
)

export default component.exports